/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Preset_Manager_Delete_TextInputs */

const en_preset_manager_delete_text = /** @type {(inputs: Preset_Manager_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete the preset "${i?.name}"? This action cannot be undone.`)
};

const fr_preset_manager_delete_text = /** @type {(inputs: Preset_Manager_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Etes-vous sur de vouloir supprimer le preset "${i?.name}" ? Cette action est irreversible.`)
};

const de_preset_manager_delete_text = /** @type {(inputs: Preset_Manager_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Möchten Sie die Voreinstellung "${i?.name}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.`)
};

const it_preset_manager_delete_text = /** @type {(inputs: Preset_Manager_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vuoi davvero eliminare il preset "${i?.name}"? Questa azione non può essere annullata.`)
};

const ru_preset_manager_delete_text = /** @type {(inputs: Preset_Manager_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вы уверены, что хотите удалить предустановку "${i?.name}"? Это действие необратимо.`)
};

const es_preset_manager_delete_text = /** @type {(inputs: Preset_Manager_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Seguro que desea eliminar el ajuste preestablecido "${i?.name}"? Esta acción no se puede deshacer.`)
};

const zh_cn2_preset_manager_delete_text = /** @type {(inputs: Preset_Manager_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`您确定要删除预设“${i?.name}”吗？此操作无法撤销。`)
};

const ja_preset_manager_delete_text = /** @type {(inputs: Preset_Manager_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プリセット「${i?.name}」を削除してもよろしいですか? この操作は元に戻せません。`)
};

const hi_preset_manager_delete_text = /** @type {(inputs: Preset_Manager_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`क्या आप वाकई प्रीसेट "${i?.name}" को हटाना चाहते हैं? यह कार्रवाई पूर्ववत नहीं की जा सकती।`)
};

const pt_pt2_preset_manager_delete_text = /** @type {(inputs: Preset_Manager_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tem certeza de que deseja excluir a predefinição "${i?.name}"? Esta ação não pode ser desfeita.`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete the preset \"{name}\"? This action cannot be undone." |
*
* @param {Preset_Manager_Delete_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_delete_text = /** @type {((inputs: Preset_Manager_Delete_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Delete_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preset_manager_delete_text(inputs)
	if (locale === "de") return de_preset_manager_delete_text(inputs)
	if (locale === "it") return it_preset_manager_delete_text(inputs)
	if (locale === "ru") return ru_preset_manager_delete_text(inputs)
	if (locale === "es") return es_preset_manager_delete_text(inputs)
	if (locale === "zh-CN") return zh_cn2_preset_manager_delete_text(inputs)
	if (locale === "ja") return ja_preset_manager_delete_text(inputs)
	if (locale === "hi") return hi_preset_manager_delete_text(inputs)
	if (locale === "pt-PT") return pt_pt2_preset_manager_delete_text(inputs)
	return en_preset_manager_delete_text(inputs)
});